var module = angular.module('octopusApp.environments');

module.directive('sshEndpoint', function() {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            endpoint: '='
        },
        templateUrl: 'areas/environments/views/endpoints/ssh_endpoint.html',
        controller: function($scope, octopusRepository, busy) {
            var isLoading = $scope.isLoading = busy.create();

            $scope.view = {};
            $scope.view.sshUseProxy = !!$scope.endpoint.ProxyId;
            $scope.view.monoInstalled = !$scope.endpoint.DotNetCorePlatform;

            $scope.dotnetCorePlatforms = ['linux-x64', 'osx-x64'];

            isLoading.promise(octopusRepository.Proxies.list().then(function (proxies) {
                $scope.proxies = proxies.Items;
            }));

            $scope.useProxyChanged = function () {
                if (!$scope.view.sshUseProxy) {
                    $scope.endpoint.ProxyId = null;
                }
            };

            $scope.clearDotNetCorePlatform = function() {
               $scope.endpoint.DotNetCorePlatform = null;
            };

            $scope.setDefaultDotNetCorePlatform = function() {
                $scope.endpoint.DotNetCorePlatform = $scope.dotnetCorePlatforms[0];
            };
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/directives/endpoints/ssh_endpoint.js
// module id = 1486031865307878
// module chunks = 1